<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation
                            >
                                <v-row>
                                    <v-col cols="12" sm="12" md="6">
                                        <DatePicker
                                            :default-date="newDateTime"
                                            v-model="newDateTime"
                                            label="Date and Time Client is Leaving"
                                            :readonly="readonly"
                                        />
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <DatePicker
                                            :default-date="newExpectedDate"
                                            v-model="newExpectedDate"
                                            label="Expected Date and time of return"
                                            :readonly="readonly"
                                        />
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <DatePicker
                                            :default-date="newActualDate"
                                            v-model="newActualDate"
                                            label="Actual Date and time of return"
                                            :readonly="readonly"
                                        />
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Who is transporting the Client?"
                                            v-model='newTransporter'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Who will be at the home when the client returns?"
                                            v-model='newReturn'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Name of Client"
                                            v-model='newClient'
                                            readonly="readonly"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Program"
                                            v-model='newProgram'
                                            :readonly="readonly"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Enter name of person taking the client"
                                            v-model="newPersonSignature"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            label="Enter name of the staff preparing the client for a visit"
                                            v-model="newStaffSignature"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-checkbox
                                            @click="addVerifiedSignature()"
                                            label="Verified By"
                                            v-model="checkVerifiedSignature"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="verifiedSigned === true">
                                        <v-text-field v-model="newVerifiedBy"
                                                      readonly></v-text-field>

                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="updateOffSite"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn class="white--text" color="#259647" @click="addVisit()"
                               v-if="createOffSite && !isAuditorRole">Save
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateVisit()" v-if="updateOffSite && !isAuditorRole">
                            Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '@/components/ClientNav'
import Foot from '@/components/Footer'
// import moment from 'moment'
import {displayError, displaySuccess} from "@/service/notification-message.service";
import {mapActions} from "vuex";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import PrintUtil from "../../../../utils/print-util";

const url = require("@/client_config/config").url;
export default {
    components: {
        DatePicker,
        ClientNav,
        Foot,
    },
    data: function () {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            msg: false,
            snackbarColor: "black",
            search: "",
            text: "",
            visits: [],
            visit: {},
            codes: [],
            users: [],
            clientID: this.$route.params.clientID,
            offSiteId: this.$route.params.id,
            userID: localStorage.getItem('userID'),
            staff: localStorage.getItem('Name'),
            tempData: [],
            titleForm: "New Off-Site Visit",
            visitID: "",
            token: localStorage.getItem('token'),
            newDateTime: "",
            newTransporter: "",
            newExpectedDate: "",
            newActualDate: "",
            newStaffSignature: "",
            newPersonSignature: "",
            newVerifiedBy: "",
            newReturn: "",
            signed: false,
            personSigned: false,
            verifiedSigned: false,
            checkVerifiedSignature: false,
            newClient: "",
            newProgram: "",
            newAcceptClient: "",
            newPreparer: "",
            isLoading: true,
            requiredRules: [
                v => !!v || 'This is required',
            ],
            readonly: true,
            disabled: true,
            createOffSite: false,
            updateOffSite: false,
        }
    },
    computed: {
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }       
    },
    watch: {},

    created() {
        this.createOffSite = this.$route.query.createOffSite === 'true';
        this.updateOffSite = this.$route.query.updateOffSite === 'true';
        if (localStorage.getItem('userRole') === 'Administration' ||
            localStorage.getItem('userRole') === 'Client Services Manager' ||
            localStorage.getItem('userRole') === 'Program Coordinator' ||
            localStorage.getItem('userRole') === 'Human Resources' ||
            localStorage.getItem('userRole') === 'Compliance Manager') {

            this.readonly = false
            this.disabled = false
        }
        this.getClientInfo(this.clientID)
        this.newClient = this.$store.state.clients.client.Name
    },

    mounted() {
        if (this.updateOffSite) {
            this.getVisit();
        }

        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.offSiteId, this.token, 'OffSiteVisit');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.offSiteId, this.token, 'OffSiteVisit');
        });
    },

    methods: {
        ...mapActions({
            getClientInfo: "clients/getClient",
        }),

        initialize() {
            this.visits = [];
        },

        validate() {
            return this.$refs.form.validate()
        },

        viewVisit(item) {
            this.titleForm = "Viewing Off-Site Visit"
            this.newDateTime = item.DateTime;
            this.newTransporter = item.Transporter;
            this.newExpectedDate = item.ExpectedDate
            this.newActualDate = item.ActualDate;
            this.newReturn = item.Return;
            this.newProgram = item.Program;
            this.visitID = item._id;
            this.newStaffSignature = item.StaffSignature;
            this.newPersonSignature = item.PersonSignature;
            if (item.VerifiedBy !== "") {
                this.newVerifiedBy = item.VerifiedBy;
                this.verifiedSigned = true;
                this.checkVerifiedSignature = true;
            }
        },

        close() {
            this.$router.go(-1);
            this.requiredTime = false;
            this.resetForm();
        },

        resetForm() {
            this.newDateTime = "";
            this.newTransporter = "";
            this.newExpectedDate = "";
            this.newActualDate = "";
            this.newReturn = "";
            this.newClient = this.$store.state.clients.client.Name;
            this.newProgram = "";
            this.newStaffSignature = "";
            this.newPersonSignature = "";
            this.newVerifiedBy = "";
        },

        async generateDownloadUrl() {
            return `${url}/offSite/print-pdf?id=${this.visitID}`;
        },

        async showPrintModal() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.offSiteId, this.token, 'OffSiteVisit');
        },

        async updateVisit() {
            let req_body = {
                DateTime: this.newDateTime,
                Transporter: this.newTransporter,
                ExpectedDate: this.newExpectedDate,
                ActualDate: this.newActualDate,
                Return: this.newReturn,
                Client: this.clientID,
                Program: this.newProgram,
                StaffSignature: this.newStaffSignature,
                PersonSignature: this.newPersonSignature,
                VerifiedBy: this.newVerifiedBy,
            };

            try {
                const response = await axios.put(`${url}/offSite/${this.visitID}`, req_body)

                if (response.status !== 200) {
                    displayError("An error occurred while updating the off-site visit record.");
                }

                displaySuccess("The off-site visit record has been updated successfully.")
                this.getVisits();
            } catch (error) {
                displayError(error);
            } finally {
                this.close();
            }
        },

        getVisits() {
            this.isLoading = true;
            axios.get(`${url}/offSite/client/${this.clientID}`).then(res => {
                this.visits = res.data.visits
            })
            this.isLoading = false;
        },

        getVisit() {
            this.isLoading = true;
            axios.get(`${url}/offSite/${this.offSiteId}`).then(res => {
                this.visit = res.data.visit;
                this.viewVisit(this.visit);
            })
            this.isLoading = false;
        },


        async addVisit() {

            let validate = this.$refs.form.validate();
            if (!validate) {
                this.snackbarColor = "red";
                this.msg = true;
                this.text = "Please fill all required fields.";
                return false;
            }

            let payload = {
                DateTime: this.newDateTime,
                Transporter: this.newTransporter,
                ExpectedDate: this.newExpectedDate,
                ActualDate: this.newActualDate,
                Return: this.newReturn,
                Client: this.clientID,
                Program: this.newProgram,
                StaffSignature: this.newStaffSignature,
                PersonSignature: this.newPersonSignature,
                VerifiedBy: this.newVerifiedBy,
            };

            try {
                const response = await axios.post(`${url}/offSite`, payload)

                if (response.status !== 200) {
                    displayError("An error occurred while adding the new off-site visit.")
                }

                displaySuccess("The new off-site visit has been added successfully.");
                this.getVisits();

            } catch (error) {
                displayError(error);
            } finally {
                this.close();
            }
        },

        addVerifiedSignature() {
            if (this.verifiedSigned === false) {
                this.newVerifiedBy = this.staff + " - " + new Date();
                this.verifiedSigned = true;
            } else {
                this.newVerifiedBy = "";
                this.verifiedSigned = false;
            }
        },

    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
